var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"editDiv",staticClass:"div-editable",attrs:{"contenteditable":""},on:{"focus":_vm.focusFunc,"keyup":_vm.getCursor,"blur":_vm.blurFunc}})}
var staticRenderFns = []

export { render, staticRenderFns }